import React from 'react';

import { Alert, Button } from 'antd';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { ACCOUNT_CONTACT_EMAIL } from '../../constants';
import { useAccountStatusBanner } from './hooks/useAccountStatusBanner';
import styles from './styles.module.less';

/** Trial, payment and read-only notice for the active organization's account. */
export const AccountStatusBanner: React.FC = () => {
  const banner = useAccountStatusBanner();

  if (!banner) return null;

  const { date, ...values } = banner.values ?? {};

  return (
    <Alert
      action={
        <Button href={`mailto:${ACCOUNT_CONTACT_EMAIL}`} size="small" type="link">
          <FormattedMessage id="accountStatus.banner.contact" />
        </Button>
      }
      banner
      className={styles.banner}
      data-kind={banner.kind}
      message={
        <FormattedMessage
          id={banner.messageId}
          values={{
            ...values,
            ...(date ? { date: <FormattedDate dateStyle="long" value={date} /> } : {}),
          }}
        />
      }
      showIcon
      type={banner.type}
    />
  );
};
